import { render, staticRenderFns } from "./ReferralTable.vue?vue&type=template&id=84cb2dc0&scoped=true"
import script from "./ReferralTable.vue?vue&type=script&lang=ts"
export * from "./ReferralTable.vue?vue&type=script&lang=ts"
import style0 from "./ReferralTable.vue?vue&type=style&index=0&id=84cb2dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cb2dc0",
  null
  
)

export default component.exports